package app.nestbridge.feature.profile.screen

import com.karawek.core.circuit.Parcelize
import app.nestbridge.domain.identity.model.ProfessionalServiceType
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.PopResult
import com.slack.circuit.runtime.screen.Screen

@Parcelize
data class CreateProfessionalProfileScreen(
    val childId: String? = null,
) : Screen

@Parcelize
data class CreateProfessionalProfileResult(
    val status: Status,
) : PopResult {
    enum class Status { Created, Cancelled }
}

data class CreateProfessionalProfileState(
    val displayName: String,
    val credentials: String,
    val practiceName: String,
    val serviceType: ProfessionalServiceType?,
    val isSaving: Boolean,
    val errorMessage: String?,
    val eventSink: (CreateProfessionalProfileEvent) -> Unit,
) : CircuitUiState

sealed interface CreateProfessionalProfileEvent {
    data object Back : CreateProfessionalProfileEvent
    data object Continue : CreateProfessionalProfileEvent
    data class UpdateDisplayName(val value: String) : CreateProfessionalProfileEvent
    data class UpdateCredentials(val value: String) : CreateProfessionalProfileEvent
    data class UpdatePracticeName(val value: String) : CreateProfessionalProfileEvent
    data class UpdateServiceType(val value: ProfessionalServiceType) : CreateProfessionalProfileEvent
}

fun CreateProfessionalProfileState.canContinue(): Boolean =
    displayName.isNotBlank() && serviceType != null && !isSaving
